/* eslint-disable import/prefer-default-export */
/**
 * This file will contain all the strings used/refernced in the react-ui.
 * For ease of maintainability, it's important to have a common source of truth for all
 * strings that will be potentially visible to users.
 * This also comes in handly if we decide to utilize a translation library in the future.
 */

export const DeploymentProgressPageStrings = {
  reload: 'Reload',
};
